import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.PRIVATE_MESSAGES_API_URL;
/*
  CREATE
*/
export const postPrivateMessage = async ({ token, message, itemNumber = null, toUser = null, toEveryone = false }) => {
    const data = {
        message
    };
    if (toUser) {
        data.toUser = toUser;
    }
    if (toEveryone) {
        data.toEveryone = toEveryone;
    }
    if (itemNumber) {
        data.itemNumber = itemNumber;
    }
    try {
        const response = await axios.post(`${API_URL}/private-messages`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('postPrivateMessage', error);
        return error.response;
    }
};
export const refreshUserCache = async (id, role) => {
    try {
        const response = await axios.post(`${API_URL}/cache/refresh-user`, {
            id,
            role
        });
        return response;
    }
    catch (error) {
        handleError('refreshUserCache', error);
        return error.response;
    }
};
/*
  READ
*/
export const getModChatIsOpen = async ({ token }) => {
    try {
        const response = await axios.get(`${API_URL}/admin/mod-chats/is-open/command`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getModChatIsOpen', error);
        return error.response;
    }
};
export const getPrivateMessageThread = async ({ token, userId, loadMore, search, itemNumber }) => {
    try {
        const response = await axios.get(`${API_URL}/private-messages/thread?${userId ? `&user=${userId}` : ''}${loadMore ? `&loadMore=${loadMore}` : ''}${search ? `&search=${search}` : ''}${itemNumber ? `&itemNumber=${itemNumber}` : ''}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessageThread', error);
        return error.response;
    }
};
export const getPrivateMessageRecent = async ({ token, itemNumber, loadMore, search }) => {
    try {
        const response = await axios.get(`${API_URL}/private-messages/recent/${itemNumber}?${loadMore ? `&loadMore=${loadMore}` : ''}${search ? `&search=${search}` : ''}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessageRecent', error);
        return error.response;
    }
};
export const getPrivateMessageHighlighted = async ({ itemNumber }) => {
    try {
        const response = await axios.get(`${API_URL}/private-messages/highlighted/${itemNumber}`);
        return response;
    }
    catch (error) {
        handleError('getPrivateMessageHighlighted', error);
        return error.response;
    }
};
export const getPrivateMessagesFree = async ({ itemNumber, loadMore }) => {
    try {
        const response = await axios.get(`${API_URL}/private-messages/free/${itemNumber}`, {
            params: {
                loadMore: loadMore || undefined
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessagesFree', error);
        return error.response;
    }
};
export const getPrivateMessagesUsers = async ({ token, loadMore, search, awaitingReply, pinned }) => {
    try {
        const response = await axios.get(`${API_URL}/users?${loadMore ? `&loadMore=${loadMore}` : ''}${search ? `&search=${search}` : ''}${awaitingReply ? `&awaitingReply=${awaitingReply}` : ''}${pinned ? `&pinned=${pinned}` : ''}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessagesUsers', error);
        return error.response;
    }
};
export const getPrivateMessageUserCounts = async ({ token }) => {
    try {
        const response = await axios.get(`${API_URL}/users/counts`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessageUserCounts', error);
        return error.response;
    }
};
export const getPrivateMessageHistoricalCounts = async ({ token, start, end }) => {
    try {
        const response = await axios.get(`${API_URL}/private-messages/counts/${start}/${end}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getPrivateMessageHistoricalCounts', error);
        return error.response;
    }
};
/*
  UPDATE
*/
export const toggleModChatIsOpen = async ({ token }) => {
    try {
        const response = await axios.put(`${API_URL}/admin/mod-chats/is-open/command`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('toggleModChatIsOpen', error);
        return error.response;
    }
};
export const updatePrivateMessage = async ({ token, id, message, highlighted = false, toEveryone = false }) => {
    try {
        const response = await axios.put(`${API_URL}/private-messages/${id}`, {
            message,
            highlighted,
            toEveryone
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('updatePrivateMessage', error);
        return error.response;
    }
};
export const updatePrivateMessageHideToEveryone = async ({ token, itemNumber }) => {
    try {
        const response = await axios.put(`${API_URL}/private-messages-hide-to-everyone/${itemNumber}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('updatePrivateMessageHideToEveryone', error);
        return error.response;
    }
};
export const updatePrivateMessageUser = async ({ token, id, data }) => {
    try {
        const response = await axios.put(`${API_URL}/users/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('updatePrivateMessageUser', error);
        return error.response;
    }
};
export const updatePrivateMessageAllUser = async ({ token, data }) => {
    try {
        const response = await axios.put(`${API_URL}/users`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('updatePrivateMessageUser', error);
        return error.response;
    }
};
export const syncUserPMs = async ({ user }) => {
    try {
        const response = await axios.post(`${API_URL}/sync-user`, user);
        return response;
    }
    catch (error) {
        handleError('syncUserPMs', error);
        return error.response;
    }
};
/*
  DELETE
*/
export const deletePrivateMessage = async ({ token, id }) => {
    try {
        const response = await axios.delete(`${API_URL}/private-messages/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('deletePrivateMessage', error);
        return error.response;
    }
};
//# sourceMappingURL=PrivateMessages.js.map